module.exports = __webpack_public_path__ + "static/media/kushki_logo.bdc37445.svg";